var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pagination"}},[_c('paginate',{attrs:{"click-handler":_vm.clickHandler,"container-class":'pagination',"prev-class":'prev-item',"next-class":'next-item',"page-class":'page-item',"page-count":_vm.pageCount,"prev-text":'<',"next-text":'>'},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-561ec40e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = MuNy
// module chunks = 1